import { ExperienceLabelDatahub, ExperienceList } from '../communityModalSurvey.constants'
import { ExperienceOptionsProps } from '../createCommunitySurvey/steps/communityCreationExperience/communityCreationExperience.types'

export enum Step {
  FirstPostExperience = 'FirstPostExperience',
  FirstPostImprovement = 'FirstPostImprovement',
  FirstPostChallenge = 'FirstPostChallenge',
  Success = 'Finish'
}

export const FIRST_POST_EXPERIENCE_OPTIONS: ExperienceOptionsProps[] = [
  {
    value: ExperienceList.VERY_EASY,
    label: 'community_survey.create_community.experience.very_easy',
    step_to_go: Step.FirstPostImprovement,
    label_value_datahub: ExperienceLabelDatahub.VeryEasy
  },
  {
    value: ExperienceList.EASY,
    label: 'community_survey.create_community.experience.easy',
    step_to_go: Step.FirstPostImprovement,
    label_value_datahub: ExperienceLabelDatahub.Easy
  },
  {
    value: ExperienceList.MEDIUM,
    label: 'community_survey.create_community.experience.medium',
    step_to_go: Step.FirstPostImprovement,
    label_value_datahub: ExperienceLabelDatahub.Medium
  },
  {
    value: ExperienceList.DIFFICULT,
    label: 'community_survey.create_community.experience.difficult',
    step_to_go: Step.FirstPostChallenge,
    label_value_datahub: ExperienceLabelDatahub.Difficult
  },
  {
    value: ExperienceList.VERY_DIFFICULT,
    label: 'community_survey.create_community.experience.very_difficult',
    step_to_go: Step.FirstPostChallenge,
    label_value_datahub: ExperienceLabelDatahub.VeryDifficult
  }
]

export const PROGRESS_BAR_VALUE_FIRST_POST_OPEN_RESPONSE_STEP = 50

export const PROGRESS_BAR_VALUE_FIRST_POST_EXPERIENCE_STEP = 0

export enum FirstPostSurveyQuestionDatahubLabel {
  Question1 = 'Como foi para você realizar sua primeira publicação na comunidade?',
  Question2 = 'Tem algo que sentiu falta ou acha que poderíamos melhorar no processo de publicação?',
  Question3 = 'O que foi difícil no processo de publicação na comunidade?'
}
